import React from "react";
import { Box } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import dayjs from "dayjs";

import { getDateFormatset } from "utils";
import { IRecDetails } from "./types";

export const REC_DETAIL_COLUMN: MRT_ColumnDef<IRecDetails>[] = [
  {
    accessorKey: "utilityProvider",
    header: "Utility Provider",
  },
  {
    accessorKey: "utilityTypeName",
    header: "Utility Type",
  },
  {
    accessorKey: "country",
    header: "Country",
  },
  {
    accessorKey: "renewableEnergy",
    header: "Coverage Percentage",
  },
  {
    accessorKey: "startDate",
    header: "Start Date",
    Cell: ({ cell }: any) => {
      const value = cell.getValue();
      return (
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box sx={{ ml: 1 }} component="span">
            {dayjs(value).format(getDateFormatset())}
          </Box>
        </Box>
      );
    },
  },
  {
    accessorKey: "endDate",
    header: "End Date",
    Cell: ({ cell }: any) => {
      const value = cell.getValue();
      return (
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box sx={{ ml: 1 }} component="span">
            {dayjs(value).format(getDateFormatset())}
          </Box>
        </Box>
      );
    },
  },
  {
    accessorKey: "siteName",
    header: "Sites Applied",
  },
];
